// eslint-disable-next-line import/no-cycle
import feathersClient from '../../feathers-client';

const defaultTagsPagination = {
	total: 100,
	$skip: 0,
	$limit: 7,
};

const defaultTagsFilter = {
	$skip: defaultTagsPagination.$skip,
	$limit: defaultTagsPagination.$limit,
};

export default {
	state: {
		tags: [],
		tagsFilter: defaultTagsFilter,
		tagsPagination: defaultTagsPagination,
		careLocations: [],
	},
	getters: {
		tagsPage: (state) => {
			const { $limit, $skip } = state.tagsPagination;
			return $skip / $limit + 1;
		},
		tags: (state) => state.tags,
	},
	mutations: {
		SET_TAGS: (state, tags) => { state.tags = tags; },
		SET_TAGS_FILTER: (state, filter) => { state.tagsFilter = { ...state.tagsFilter, ...filter }; },
		SET_DEFAULT_TAGS_FILTER: (state, filter) => { state.tagsFilter = { ...filter, ...defaultTagsFilter }; },
		SET_TAGS_PAGINATION: (state, data) => { state.tagsPagination = { ...state.tagsPagination, ...data }; },
	},
	actions: {
		loadGroupingTagsWithPagination: async ({ commit, rootGetters }, filter) => {
			const url = '/api/v3/skillgroupingtags';
			const results = await feathersClient.service(url).find({
				query: {
					$role: rootGetters.currentUserRole,
					fields: ['owner'],
					...filter,
				},
			});
			commit('SET_TAGS', results.data);
			commit('SET_TAGS_PAGINATION', { total: results.total });
			return results.data;
		},
		setTagsFilter: ({ commit }, filter) => {
			commit('SET_TAGS_FILTER', filter);
		},
		setDefaultTagsFilter: ({ commit }, filter) => {
			commit('SET_DEFAULT_TAGS_FILTER', filter);
		},
		setTagsPage: ({ commit, state }, page) => {
			const $skip = (page - 1) * state.tagsPagination.$limit;
			commit('SET_TAGS_PAGINATION', { $skip });
			commit('SET_TAGS_FILTER', { $skip });
		},
		createNewGroupingTag: async ({ rootGetters }, newTag) => {
			const url = 'api/v3/skillgroupingtags';
			const results = await feathersClient.service(url).create(newTag, {
				query: {
					$role: rootGetters.currentUserRole,
				},
			});
			return results;
		},
		updateTag: async ({ rootGetters }, data) => {
			const id = data.id;
			delete data.id;
			const url = 'api/v3/skillgroupingtags';
			const results = await feathersClient.service(url).patch(id, data, {
				query: {
					$role: rootGetters.currentUserRole,
				},
			});
			return results;
		},
		getTagById: async({ rootGetters }, id) => {
			const url = '/api/v3/skillgroupingtags';
			const results = await feathersClient.service(url).get(id, {
				query: {
					$role: rootGetters.currentUserRole,
					fields: ['owner'],
				},
			});
			return results;
		},
		createNewTag: async ({ rootGetters }, newTag) => {
			const url = 'api/v3/skillgroupingtags';
			const results = await feathersClient.service(url).create(newTag, {
				query: {
					$role: rootGetters.currentUserRole,
				},
			});
			return results;
		},
		deleteTags: async ({ rootGetters }, filter) => {
			const url = '/api/v3/skillgroupingtags';
			const result = await feathersClient.service(url).remove(null, {
				query: {
					$role: rootGetters.currentUserRole,
					_id: { $in: filter.tags },
				},
			});
			return result;
		},
	},
};
